import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  fetchActivitiesByUseCaseDone,
  fetchActivitiesByUseCaseError,
  fetchActivitiesByUseCaseLoading,
  fetchActivitiesByUseCaseSuccess,
  fetchHeroesDone,
  fetchHeroesError,
  fetchHeroesLoading,
  fetchHeroesSuccess,
  fetchPopinsDone,
  fetchPopinsError,
  fetchPopinsLoading,
  fetchPopinsSuccess,
  fetchTenantStatsDone,
  fetchTenantStatsError,
  fetchTenantStatsLoading,
  fetchTenantStatsSuccess,
  fetchUsersDone,
  fetchUsersError,
  fetchUsersLoading,
  fetchUsersSuccess
} from '../actions/tenantStats';
import { adminApi } from '../api/AdminApi';
import {
  FETCH_ACTIVITIES_BY_USE_CASE,
  FETCH_HEROES,
  FETCH_POPINS,
  FETCH_TENANT_STATS,
  FETCH_USERS
} from '../actions/actionTypes';

// FETCH_TENANT_STATS

export function* watchFetchTenantStatsSaga () {
  yield takeLatest(FETCH_TENANT_STATS, fetchTenantStatsSaga);
}

export function* fetchTenantStatsSaga ({ tenantId, numWeeks }) {
  try {
    yield put(fetchTenantStatsLoading());
    const tenantStats = yield call(adminApi.fetchTenantStats, tenantId, numWeeks);
    yield put(fetchTenantStatsSuccess(tenantStats));
  } catch (error) {
    yield put(fetchTenantStatsError(error));
  } finally {
    yield put(fetchTenantStatsDone());
  }
}

// FETCH_ACTIVE_USERS

export function* watchFetchUsersSaga () {
  yield takeLatest(FETCH_USERS, fetchUsersSaga);
}

export function* fetchUsersSaga ({ tenantId, numWeeks }) {
  try {
    yield put(fetchUsersLoading());
    const activeUsers = yield call(adminApi.fetchUsers, tenantId, numWeeks);
    yield put(fetchUsersSuccess(activeUsers));
  } catch (error) {
    yield put(fetchUsersError(error));
  } finally {
    yield put(fetchUsersDone());
  }
}

// FETCH_HEROES

export function* watchFetchHeroesSaga () {
  yield takeLatest(FETCH_HEROES, fetchHeroesSaga);
}

export function* fetchHeroesSaga ({ tenantId, numWeeks }) {
  try {
    yield put(fetchHeroesLoading());
    const heroes = yield call(adminApi.fetchHeroes, tenantId, numWeeks);
    yield put(fetchHeroesSuccess(heroes));
  }

  catch (error) {
    yield put(fetchHeroesError(error));
  }
  finally {
    yield put(fetchHeroesDone());
  }
}

// FETCH_POPINS

export function* watchFetchPopinsSaga () {
  yield takeLatest(FETCH_POPINS, fetchPopinsSaga);
}

export function* fetchPopinsSaga ({ tenantId, numWeeks }) {
  try {
    yield put(fetchPopinsLoading());
    const popins = yield call(adminApi.fetchPopins, tenantId, numWeeks);
    yield put(fetchPopinsSuccess(popins));
  }

  catch (error) {
    yield put(fetchPopinsError(error));
  }
  finally {
    yield put(fetchPopinsDone());
  }
}

// FETCH ACTIVITIES BY USE CASE

export function* watchFetchActivitiesByUseCaseSaga () {
  yield takeLatest(FETCH_ACTIVITIES_BY_USE_CASE, fetchActivitiesByUseCaseSaga);
}

export function* fetchActivitiesByUseCaseSaga ({ tenantId, numWeeks }) {
  try {
    yield put(fetchActivitiesByUseCaseLoading());
    const result = yield call(adminApi.fetchActivitiesByUseCase, tenantId, numWeeks);
    yield put(fetchActivitiesByUseCaseSuccess(result));
  } catch (error) {
    yield put(fetchActivitiesByUseCaseError(error));
  } finally {
    yield put(fetchActivitiesByUseCaseDone());
  }
}

export default [
  fork(watchFetchTenantStatsSaga),
  fork(watchFetchUsersSaga),
  fork(watchFetchHeroesSaga),
  fork(watchFetchPopinsSaga),
  fork(watchFetchActivitiesByUseCaseSaga)
];
